<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div v-if="items?.total > 3">
      <div class="flex items-center justify-between px-4 py-3 bg-white sm:px-6">
        <div class="flex flex-wrap items-center justify-between flex-1">
          <div class="w-full md:w-[30%] mb-6 md:mb-0 flex items-center justify-between md:justify-start">
          </div>
          <div class="w-full md:w-[70%] text-center md:text-right">
            <nav
              class="relative z-0 inline-flex -space-x-px rounded-lg"
              aria-label="Pagination"
            >
              <template v-for="(link, key) in items.links" :key="key">
                <button
                  v-if="key === 0"
                @click="$emit('nextPage', link.url)"
                  class="
                    relative
                    inline-flex
                    items-center
                    px-2
                    py-2
                    bg-white
                    text-sm
                    font-medium
                    text-gray-500
                    hover:bg-gray-[#F3F4F6]
                  "
                >
                  <span class="sr-only">Previous</span>
                  <ChevronLeftIcon class="w-5 h-5" aria-hidden="true" />
                </button>
                <button
                  v-else-if="key === items.links.length - 1"
                @click="$emit('nextPage', link.url)"
                  class="
                    relative
                    inline-flex
                    items-center
                    px-2
                    py-2
                    bg-white
                    text-sm
                    font-medium
                    text-gray-500
                    hover:bg-gray-[#F3F4F6]
                  "
                >
                  <span class="sr-only">Next</span>
                  <ChevronRightIcon class="w-5 h-5" aria-hidden="true" />
                </button>
                <button
                  v-else
                    @click="$emit('nextPage', link.url)"
                  aria-current="page"
                  :class="
                    link.active
                      ? 'z-10 bg-[#F3F4F6] border-[#F3F4F6] relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-lg'
                      : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg'
                  "
                >
                  {{ link.label }}
                </button>
              </template>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/24/solid";
  defineProps({
    items: Object || null,
    rowCount: {
      type: Number,
      default: 10
    },
    goToPage: {
      type: String,
      default: null
    }
  })
  </script>
  